import React from 'react';
import PriceListGroupLines from '../../containers/PriceListGroupLines/PriceListGroupLines';

const PriceListGroupLinesPage = () => {
  return <PriceListGroupLines />;
};

export default PriceListGroupLinesPage;
